import { render, staticRenderFns } from "./IotModelPointsGroupModal.vue?vue&type=template&id=dbba6dfa&scoped=true&"
import script from "./IotModelPointsGroupModal.vue?vue&type=script&lang=js&"
export * from "./IotModelPointsGroupModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dbba6dfa",
  null
  
)

export default component.exports